// ofa-status.component.ts
import { Component, Input } from '@angular/core';
import { getStatusClasses } from './ofa-status';

@Component({
  selector: 'app-ofa-status',
  template: `
  <div *ngFor="let step of steps; let i = index"
       [ngClass]="{'step step-active': isStepActive(step), 'step': !isStepActive(step)}">
    <div class="step-content">
      <div class="circle">{{ i + 1 }}</div>
      <div class="title">{{ step }}</div>
      <div *ngIf="step === getDisplayStatut(ofa?.statut)" class="badge fw-bolder fs-1" [ngClass]="getStatusClasses(ofa?.statut)" style="font-size: 17px;">
        {{ getDisplayStatut(ofa?.statut) }}
      </div>
    </div>
</div>

  `,
  styles: [`
/* ofa-status.component.css */
.step {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.step-content {
  display: flex;
  align-items: center;
}

.circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #007bff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  font-weight: bold;
}

.title {
  font-size: 16px;
  font-weight: normal;
}

  `]
})
export class OfaStatusComponent {
    @Input() ofa: any;

    steps = ['Initialisée', 'En attente', 'Soumise', 'Validée', 'Analysée', 'Arbitrée', 'Traitée', 'Archivée'];
  
    getStatusClasses(statut: string) {
      return getStatusClasses(statut);
    }
  
    isStepActive(step: string): boolean {
      const stepMapping = {
        'Initialisée': ['initialisé', 'en attente', 'soumis', 'validé', 'analysé', 'retourné', 'arbitré', 'traité', 'archivé'],
        'En attente': ['en attente', 'soumis', 'validé', 'analysé', 'retourné', 'arbitré', 'traité', 'archivé'],
        'Soumise': ['soumis', 'validé', 'analysé', 'retourné', 'arbitré', 'traité', 'archivé'],
        'Validée': ['validé', 'analysé', 'retourné', 'arbitré', 'traité', 'archivé'],
        'Analysée': ['analysé', 'retourné', 'arbitré', 'traité', 'archivé'],
        'Arbitrée': ['arbitré', 'traité', 'archivé'],
        'Traitée': ['traité', 'archivé'],
        'Archivée': ['archivé']
      };
      return stepMapping[step].includes(this.ofa.statut);
    }
  
    getDisplayStatut(statut: string): string {
      const statutMapping = {
        'initialisé': 'Initialisé',
        'en attente': 'En attente',
        'soumis': 'Soumis',
        'validé': 'Validé',
        'analysé': 'Analysé',
        'retourné': 'Retourné',
        'arbitré': 'Arbitré',
        'traité': 'Traité',
        'archivé': 'Archivé',
        'effectué': 'Effectué',
        'accepté': 'Accepté',
        'planifié': 'Planifié',
        'approuvé': 'Approuvé',
        'revu': 'Revu',
      };
      return statutMapping[statut] || 'Statut inconnu';
    }
  }
